<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">

    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="w-full">
        <img src="assets/images/icons/feedback-submit.svg" class="m-auto pb-4" alt="feedback logo" />
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color text-center">Feedback Submitted
        </h2>
        <p class="text-center text-blue-theme-color py-4">Thank you for taking the time to review and rate your delivery
            personnel. Your feedback
            helps us enhance the experience for everyone.</p>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="mt-2 !pb-5 !px-0 justify-center">

    <button (click)="onClose()"
        class="!bg-blue-theme-color w-full   flex justify-center flat-button items-center  !px-6 md:!h-14 sm:!h-10 !h-10 text-white-color hover:opacity-[0.9]"
        mat-flat-button>
        Thank You!
    </button>
</mat-dialog-actions>